export default class Licenses {
  constructor(api) {
    this.api = api;
  }

  getFieldLicenses(onSuccess, onError) {
    return this.api.http_field_license
      .get("licenses.md")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getFibercloudLicenses(onSuccess, onError) {
    return this.api.http_fibercloud_license
      .get("licenses.md")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/licenses.js